export default {"src":"/_next/static/media/logo.4f6bfa30.svg","height":60,"width":119,"blurWidth":0,"blurHeight":0};